import type { BackgroundComplementaryScale } from '../../../types/theme';
import { rgba } from '../../../utils/colors';

export const backgroundComplementary: BackgroundComplementaryScale = {
  1: opacity => rgba(197, 129, 65, opacity),
  2: opacity => rgba(255, 143, 92, opacity),
  3: opacity => rgba(238, 189, 75, opacity),
  4: opacity => rgba(222, 240, 65, opacity),
  5: opacity => rgba(244, 111, 115, opacity),
  6: opacity => rgba(135, 232, 148, opacity),
  7: opacity => rgba(96, 132, 238, opacity),
  8: opacity => rgba(90, 182, 232, opacity),
  9: opacity => rgba(48, 223, 230, opacity),
  10: opacity => rgba(233, 79, 138, opacity),
  11: opacity => rgba(249, 105, 215, opacity),
  12: opacity => rgba(200, 219, 239, opacity),
};
